import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css'
import './css/font-awesome.min.css'
import './css/themify-icons.css'
import './css/flaticon-set.css'
import './css/magnific-popup.css'
import './css/owl.carousel.min.css'
import './css/owl.theme.default.min.css'
import './css/animate.css'
import './css/bootsnav.css'
import './css/style.css'
import './css/responsive.css'
import 'bootstrap/dist/js/bootstrap.bundle';
import './js/jquery.appear.js'
import './js/count-to.js'
import './js/bootsnav.js'
import App from './App';
import reportWebVitals from './reportWebVitals';

// Need this for React Routes to work when hosting on S3.
// Also configure Redirection rules on S3. https://via.studio/journal/hosting-a-reactjs-app-with-routing-on-aws-s3
// Set up the browser history with the updated location (minus the # sign)
// const history = createBrowserHistory();
// const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
// if (path) {
//   history.replace(path);
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  //   <App />
  // </React.StrictMode>
  <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
